// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dash-box {\n  width: 100%;\n  height: 8rem;\n  border-radius: 0.3rem;\n}", "",{"version":3,"sources":["webpack://src/components/DashboardModule/styles.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;AACF","sourcesContent":[".dash-box {\n  width: 100%;\n  height: 8rem;\n  border-radius: 0.3rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
